export interface Theme {
  background?: number;
  button?: number;
  paragraph?: number;
  title?: number;
  interaction?: number;
  logoUrl?: string;
}

type Subscriber = (theme: Theme | undefined) => void;

export class ThemeManager {
  private subscribers: Subscriber[];
  private theme: Theme | undefined;
  constructor() {
    this.subscribers = [];
  }


  setTheme(newTheme: Theme): void {
    this.theme = newTheme
    this.subscribers.forEach(cb => cb(this.theme));
  }

  getTheme(): Theme | undefined {
    return this.theme;
  }

  subscribe(cb: Subscriber): void {
    this.subscribers.push(cb);
    if (this.theme) {
      cb(this.theme);
    }
  }

  unsubscribe(cb: Subscriber | undefined): void {
    this.subscribers = this.subscribers.filter(fn => fn !== cb);
  }
}

export const themeManager = new ThemeManager();
